import { usePage } from "@inertiajs/vue3";
import { nextTick } from "vue";

export function choose(values) {
    if (!Array.isArray(values)) {
        return values
    }

    const idx = Math.floor(seededRand() * values.length)

    return values[idx]
}

export function env() {
    return import.meta.env
}

export function setCssVar(name, value) {
    document.documentElement.style.setProperty(name, value);
}

export function clamp(val, low, high) {
    return Math.max(low, Math.min(val, high))
}

export function lerp(low, high, fact) {
    return low + (high-low)*fact
}

/**
 * @param {any} data 
 * @returns 
 * - If the input is an array, return a new array with each value stringified
 * - Else, return an array containing the input stringified
 * @example 
 * // returns ["1"]
 * toStingArray(1)
 * // returns ["a"]
 * toStingArray("a")
 * // returns ["1", "2"]
 * toStingArray([1, 2])
 * // returns ["1", "2", "true", "foo"]
 * toStingArray([1, 2, true, "foo"])
 */
export function toStringArray(data) {
    if (!Array.isArray(data)) {
        return [String(data)]
    }

    return data.map((v) => String(v))
}

String.prototype.flip = function () {
    return [...this].reverse().join("")
}

export function modalShown() {
    return document.querySelector("dialog:modal") !== null
}

// Seed-able PRNG since JS is the only language without a seed-able rand generator
function mulberry32(seed) {
    if (!seed || !env().DEV) {
        return Math.random
    }

    console.log(`Initializing PRNG with seed: ${seed}`)
    return () => {
        let t = (seed += 0x6D2B79F5);
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

export const seededRand = mulberry32(parseInt(env().VITE_RAND_SEED))

export function scrollToLastNext(elem) {
    const child = elem.lastElementChild

    if (!child) {
        return
    }

    nextTick(() => {
        child.scrollIntoView({
            behavior: 'smooth'
        })
    })
}

export function timeToSession(timeKey = "startTime") {
    const session = usePage().props.chatSessionData
    const now = (new Date()).valueOf() / 1_000

    return session[timeKey] - now
}

export function groupSize() {
    return 2*Number(env().VITE_PAIRS_IN_GROUP ?? 3)
}

export function roundsCount() {
    // Authoritative source: the server sends roundsPerPhase (the session's rounds_per_phase,
    // the same value the backend created the rounds from), so the client can't
    // disagree with it about when a phase ends. The build-time VITE_PAIRS_IN_GROUP fallback
    // only applies if the config payload is absent, which it never is in the participant /
    // consultant apps
    const fromServer = Number(usePage().props.experimentConfigData?.roundsPerPhase)
    return Number.isFinite(fromServer) && fromServer > 0 ? fromServer : groupSize()-1
}

export function roundNDigits(value, decimalDigits) {
    decimalDigits = Math.floor(decimalDigits)

    if (decimalDigits <= 0) {
        return Math.floor(value)
    }

    const p = Math.pow(10, decimalDigits)

    return Math.floor(value*p) / p
}

export function loggedIn() {
    const props = usePage().props

    // experimentConfigData is an Inertia prop passed to both consultants and participants
    // but only when logged in
    return "experimentConfigData" in props 
}